import { Link } from "react-router-dom";
import RegStrip from "../components/RegStrip.jsx";
import { faviconUrl } from "../lib/cms.js";

export default function Group() {
  return (
    <>
      <section className="page-header">
        <div className="wrap">
          <div className="eyebrow">The group</div>
          <h1>A merchant banking group, built across three jurisdictions.</h1>
          <p className="sub">
            Daksfirst Limited is a UK private investment firm operating as an Appointed
            Representative of Maystone Capital Limited, which is authorised and regulated by
            the Financial Conduct Authority. FCA Firm Reference Number 758412.
            AR registration 937220.
          </p>
        </div>
      </section>

      <section>
        <div className="wrap" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 64 }}>
          <div>
            <div className="eyebrow">What we do</div>
            <h2 style={{ color: "var(--white)", marginTop: 14, maxWidth: "20ch" }}>
              Specialist credit, originated and managed in-house.
            </h2>
          </div>
          <div>
            <p className="sub">
              Capital is deployed across three regulated fund vehicles, four UK and India
              lending platforms, and direct co-investment alongside the group.
            </p>
            <p className="sub spacer-s">
              The group focuses on credit opportunities driven by operational complexity,
              structural friction, or limited data availability — areas underserved by
              mainstream lenders.
            </p>
            <div className="hero-actions" style={{ marginTop: 28 }}>
              <Link className="btn btn-primary" to="/invest">Invest with us</Link>
              <Link className="btn btn-ghost"   to="/borrow">Borrow from us</Link>
            </div>
          </div>
        </div>
      </section>

      <RegStrip rows={[
        ["Legal entity",      "Daksfirst Limited"],
        ["UK company number", "11626401"],
        ["VAT number",        "373672277"],
        ["AR registration",   "937220"]
      ]} />

      <section>
        <div className="wrap">
          <div className="eyebrow">In-house technology</div>
          <h2 style={{ color: "var(--white)", marginTop: 14, maxWidth: "30ch" }}>
            Cepheus Analytics — the group's analytics and origination platform.
          </h2>
          <p className="sub spacer-s">
            Cepheus Analytics is the Daksfirst Group's UK-based technology and analytics arm,
            formed in 2014. It builds and maintains the loan-origination systems used across
            the group — including the Daksfirst LOS for India (deployed at IFHL) and the
            Daksfirst Bridge Lending LOS used by the UK platform. Cepheus also has a track
            record in underwriting and scorecard analytics, loan servicing technology, and
            securitisation modelling for third-party financial firms and private equity clients.
          </p>
          <div className="ext-links spacer-m" style={{ justifyContent: "flex-start" }}>
            <a href="https://www.cepheusanalytics.com" target="_blank" rel="noopener noreferrer" className="btn btn-ghost">
              Visit cepheusanalytics.com ↗
            </a>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap">
          <div className="eyebrow">Group entities</div>
          <h2 style={{ color: "var(--white)", marginTop: 14, maxWidth: "26ch" }}>
            Where the group's capabilities are anchored.
          </h2>
          <div className="entities-grid spacer-m">
            <a className="entity-card" href="https://kifpl.com" target="_blank" rel="noopener noreferrer">
              <div className="entity-logo"><img src={faviconUrl("https://kifpl.com", 128)} alt="KIFPL" loading="lazy" /></div>
              <div className="eyebrow">India · NBFC</div>
              <h3>KIFPL</h3>
              <p>Komac Investments and Finance Private Limited — RBI-registered NBFC providing private credit exposure across fintechs, origination platforms and SME anchors.</p>
              <span className="entity-go">kifpl.com ↗</span>
            </a>
            <a className="entity-card" href="https://ifhl.in" target="_blank" rel="noopener noreferrer">
              <div className="entity-logo entity-logo-dark"><img src="/logos/ifhl.jpg" alt="IFHL" loading="lazy" /></div>
              <div className="eyebrow">India · LSP</div>
              <h3>IFHL</h3>
              <p>India Finance House — loan service provider for KIFPL.</p>
              <span className="entity-go">ifhl.in ↗</span>
            </a>
            <a className="entity-card" href="https://www.cepheusanalytics.com" target="_blank" rel="noopener noreferrer">
              <div className="entity-logo entity-logo-light"><img src="/logos/cepheus.png" alt="Cepheus Analytics" loading="lazy" /></div>
              <div className="eyebrow">UK · Technology</div>
              <h3>Cepheus Analytics</h3>
              <p>The group's UK-based technology and analytics arm. Builds and maintains the loan origination systems across Daksfirst.</p>
              <span className="entity-go">cepheusanalytics.com ↗</span>
            </a>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap" style={{ textAlign: "center" }}>
          <div className="eyebrow">Senior team</div>
          <h2 style={{ color: "var(--white)", marginTop: 14, marginBottom: 18 }}>
            Direct points of contact across the group.
          </h2>
          <Link className="btn btn-primary" to="/team">View the team →</Link>
        </div>
      </section>
    </>
  );
}
